import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { ProfileAvatarCircle } from './ProfileAvatarCircle';

const ProfileAvatarCircleBridge = react2angular(ProfileAvatarCircle, [
  'fullname',
  'size'
]);

export default ProfileAvatarCircleBridge;
